import Technologies from "./Technologies";
export default Technologies;